/* eslint-disable no-extend-native */
Date.prototype.Format = function (fmt = 'yyyy-MM-dd') {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds(),
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

/* eslint-disable no-extend-native */
Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'H+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds(),
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}
export const enumTimeFunc = {
  today: () => {
    const now = new Date()
    let startDay = new Date(
      now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
    )
    let endDay = new Date(
      now.getFullYear() +
        '-' +
        (now.getMonth() + 1) +
        '-' +
        now.getDate() +
        ' ' +
        '23:59:59'
    )
    return [startDay, endDay].map((v) => v.Format('yyyy-MM-dd hh:mm:ss'))
  },
  yesterday: () => {
    const now = new Date()
    let startDay = new Date(
      now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
    )
    startDay.setTime(startDay.getTime() - 3600 * 1000 * 24)
    let endDay = new Date(
      now.getFullYear() +
        '-' +
        (now.getMonth() + 1) +
        '-' +
        now.getDate() +
        ' ' +
        '23:59:59'
    )
    endDay.setTime(endDay.getTime() - 3600 * 1000 * 24)
    return [startDay, endDay].map((v) => v.Format('yyyy-MM-dd hh:mm'))
  },
  lastMonth: () => {
    const now = new Date()
    let startDay = new Date(
      now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
    )
    startDay.setDate(1)
    startDay.setMonth(startDay.getMonth() - 1)
    const endDay = new Date(
      now.getFullYear() +
        '-' +
        (now.getMonth() + 1) +
        '-' +
        now.getDate() +
        ' ' +
        '23:59:59'
    )
    endDay.setDate(0)
    return [startDay, endDay].map((v) => v.Format('yyyy-MM-dd hh:mm'))
  },
  thisYear: () => {
    const now = new Date()
    let startDay = new Date(
      now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
    )
    startDay.setDate(1)
    startDay.setMonth(0)
    return [startDay, now].map((v) => v.Format('yyyy-MM-dd hh:mm'))
  },
  thisWeek: () => {
    const now = new Date()
    let startDay = new Date(
      now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
    )
    startDay.setDate(startDay.getDate() - startDay.getDay() + 1)
    return [startDay, now].map((v) => v.Format('yyyy-MM-dd hh:mm'))
  },
  thisMonth: () => {
    const now = new Date()
    let startDay = new Date(
      now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
    )
    startDay.setDate(1)
    return [startDay, now].map((v) => v.Format('yyyy-MM-dd hh:mm'))
  },
  'thisWeek-fulltime': () => {
    const start = new Date()
    const oneDay = 24 * 60 * 60 * 1000
    start.setDate(start.getDate() - start.getDay() + 1)
    const now = new Date()
    let nowTime = now.getTime()
    let day = now.getDay() // 本周的第几天
    let SundayTime = new Date(nowTime + (7 - day) * oneDay + 0 * 7 * oneDay)
    return [start, SundayTime].map((v) => v.Format('yyyy-MM-dd hh:mm'))
  },
  'thisMonth-fulltime': () => {
    const start = new Date()
    start.setDate(1)
    const end = new Date()
    let currentYear = end.getFullYear()
    let currentMonth = end.getMonth()
    let currentMonthLastDay = new Date(currentYear, currentMonth + 1, 0)
    return [start, currentMonthLastDay].map((v) => v.Format('yyyy-MM-dd hh:mm'))
  },
}



// WEBPACK FOOTER //
// ./src/utils/Date.js